import React from 'react';
import { Truck, MessageCircle, Clock, CreditCard } from 'lucide-react';

const ShippingFeeConsult = ({ orderDetails }) => {
  const handleWhatsAppClick = () => {
    const phoneNumber = process.env.REACT_APP_WHATSAPP_NO;
    const message = `Hello! My name is *${orderDetails.name}*.\n I'd like to confirm the shipping fee for my order *#${orderDetails.reference}*.\n\n` +
      `*Delivery Address:* _${orderDetails.shippingAddress}_\n\n` +
      `*Order Details:*\n${orderDetails.orderItems.map(item => 
        `- *${item.productName}* (Size: *${item.productSize.size}*, Quantity: *${item.productQuantity}*)`
      ).join('\n')}\n\n` +
      `Please provide shipping options and payment methods available. Thank you!`;
      
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden mt-4 mb-4 md:mb-10 sm:mt-6">
      <div className="p-3 sm:p-4 md:p-6 border-b border-gray-200">
        <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
          <Truck className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600" />
          <h3 className="text-base sm:text-lg font-semibold text-gray-800">
            Get Your Shipping Quote
          </h3>
        </div>
        
        <div className="space-y-3 sm:space-y-4">
          <div className="bg-blue-50 rounded-lg p-3 sm:p-4">
            <p className="text-xs sm:text-sm text-blue-800">
              Congratulations! Your order has been confirmed. Click below to get your shipping quote and choose your preferred payment method.
            </p>
          </div>
          
          <div className="space-y-3">
            <div className="flex items-start gap-2 text-xs sm:text-sm text-gray-600">
              <Clock className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 mt-0.5" />
              <span>Shipping quote will be provided within 1-2 hours</span>
            </div>
            
            <div className="flex items-start gap-2 text-xs sm:text-sm text-gray-600">
              <CreditCard className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 mt-0.5" />
              <div className="space-y-1">
                <p className="font-medium">Available Payment Options:</p>
                <ul className="ml-4 list-disc">
                    <li>Payment before delivery</li>
                    {/* <li>Cash on delivery</li> */} {/* Uncomment if needed */}
                </ul>
              </div>
            </div>
          </div>
          
          <div className="pt-2">
            <button
              onClick={handleWhatsAppClick}
              className="w-full sm:w-auto flex items-center justify-center gap-1.5 sm:gap-2 bg-green-500 hover:bg-green-600 text-white px-4 sm:px-6 py-2.5 rounded-lg transition-colors text-sm sm:text-base font-medium"
            >
              <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>Get Shipping Quote</span>
            </button>
            <p className="mt-2 text-[11px] sm:text-xs text-gray-500 text-center sm:text-left">
              Click to discuss shipping options and payment preferences via WhatsApp
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingFeeConsult;